<div class="action" [ngClass]="{ active: action().isActive }">
  <button
    class="action"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd()"
  >
    <i
      class="fal fa-{{ action().icon }}"
      [style.color]="action().iconColor || black()"
    ></i>
  </button>
</div>
